import { ComponentView } from "binder";
import { Position, PopupViewModel } from "./popup-viewModel"

export class PopupView extends ComponentView<PopupViewModel>{
    GetViewUniqueId(): string {
        return "V-5F4C0889-81F6-4F85-8104-BAD5511913A2"
    }
    loadHtml(): string {
        let element = require('./popup.html').default;
        let style = require('./popup.less');
        return element;
    }
    constructor() {
       super();
    }

    private resizeObserver : ResizeObserver;
        

    private _childPlaceHolder:HTMLElement;
    append(...nodes: (Node | string)[]): void{
        this._childPlaceHolder.append(...nodes);
    }

    onRenderCompleted(){
        super.onRenderCompleted();
        this._childPlaceHolder = <HTMLElement>this.firstlevelElement.querySelector('.V-5F4C0889-81F6-4F85-8104-BAD5511913A2-childPlaceHolder');
    }

    public set origin(v: Position) { this._origin = v; } public get origin(): Position { return this._origin;} private _origin: Position;
    public set top(v: number) { this._top = v; } public get top(): number { return this._top;} private _top: number;
    public set left(v: number) { this._left = v; } public get left(): number { return this._left;} private _left: number;
    public set zindex(v: number) { this._zindex = v; } public get zindex(): number { return this._zindex;} private _zindex: number;
    public set preferredwidth(v: string) { this._preferredwidth = v; } public get preferredwidth(): string { return this._preferredwidth;} private _preferredwidth: string;
    public set usebody(v: boolean) { this._usebody = v; } public get usebody(): boolean { return this._usebody;} private _usebody: boolean;
    
    private static usedZIndices:number[]=[10];
    private realParent : HTMLElement;
    public set isShowing(v: boolean) { 
        if(this.firstlevelElement==null) return;
        if(v){
            if(this.usebody){
                this.realParent = this.firstlevelElement.parentElement;
                this.realParent.removeChild(this.firstlevelElement);
                document.body.appendChild(this.firstlevelElement);    
            }
            if(v && (this.isShowing==undefined|| this._isShowing==false)){
                this.resizeObserver = new ResizeObserver(entries =>{
                    for(let entry of entries){
                        if(entry.target==this.firstlevelElement){
                            console.log("observe")
                            this.show();
                        }
                    }
                });
                this.resizeObserver.observe(this.firstlevelElement);
                this.show();
            }
        }else{
            if(this.usebody){
                document.body.removeChild(this.firstlevelElement);
                this.realParent.appendChild(this.firstlevelElement);
            }
            if(this.resizeObserver){
                this.resizeObserver.unobserve(this.firstlevelElement);
                this.resizeObserver.disconnect();
                this.resizeObserver = null;

            }
            if(this.zindex && this.zindex!=0){
                let index = PopupView.usedZIndices.indexOf(this.zindex);
                if(index>-1)
                    PopupView.usedZIndices.splice(index,1);
            }
        }
        this._isShowing = v; 
    } public get isShowing(): boolean { return this._isShowing;} private _isShowing: boolean;
    show(){
        let popupPosition = this.getTopLeftPosition();
        (<HTMLElement> this.firstlevelElement).style.top = popupPosition.y+'px';
        (<HTMLElement> this.firstlevelElement).style.left = popupPosition.x+'px';
        let maxIndex =  PopupView.usedZIndices.reduce((a,c)=>c>a?c:a,0);
        this.zindex = maxIndex+1;
        PopupView.usedZIndices.push(this.zindex);
    }
    private getTopLeftPosition(){
        let result:Position=new Position(0,0);
        let rect =(<HTMLElement> this.firstlevelElement).getBoundingClientRect();
        
        if(this.origin.x + this.origin.width + Math.abs(rect.width) < window.innerWidth)
            result.x = this.origin.x + this.origin.width;
        else if(this.origin.x - Math.abs(rect.width) > 0)
            result.x = this.origin.x - Math.abs(rect.width);
        else
            result.x = (window.innerWidth - rect.width)/2;
        if(this.origin.y + this.origin.height + Math.abs(rect.height) < window.innerHeight)
            result.y = this.origin.y + this.origin.height;
        else if(this.origin.y - Math.abs(rect.height) > 0)
            result.y = this.origin.y - Math.abs(rect.height);
        else
            result.y = (window.innerHeight - rect.height)/2;
        console.log(`result : ${result.x},${result.y},${result.width},${result.height}`);
        return result;
    }
}
